var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatatacarIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7EC4_329",
    "data-name": "\\u7EC4 329",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #e0e0e0;\n      }\n\n      .cls-5 {\n        fill: #363636;\n      }\n\n      .cls-6 {\n        fill: #5e5e5e;\n      }\n\n      .cls-7 {\n        fill: #434343;\n      }\n\n      .cls-8 {\n        fill: #ddd;\n      }\n\n      .cls-9 {\n        fill: #f4852a;\n      }\n\n      .cls-10 {\n        fill: aqua;\n      }\n\n      .cls-11 {\n        fill: #828282;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_90",
    "data-name": "\\u77E9\\u5F62 90",
    className: "cls-1",
    width: 70,
    height: 40.592
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_91",
    "data-name": "\\u77E9\\u5F62 91",
    className: "cls-2",
    width: 70,
    height: 70
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_328",
    "data-name": "\\u7EC4 328",
    transform: "translate(0 29.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_327",
    "data-name": "\\u7EC4 327",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_324",
    "data-name": "\\u8DEF\\u5F84 324",
    className: "cls-4",
    d: "M3.455,39.458V1.133A1.133,1.133,0,0,1,4.589,0H68.314a1.133,1.133,0,0,1,1.134,1.133V39.458a1.134,1.134,0,0,1-1.134,1.134H4.589a1.134,1.134,0,0,1-1.134-1.134",
    transform: "translate(0.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_325",
    "data-name": "\\u8DEF\\u5F84 325",
    className: "cls-5",
    d: "M0,39.458V1.133A1.133,1.133,0,0,1,1.134,0H65.993V40.592H1.134A1.134,1.134,0,0,1,0,39.458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_326",
    "data-name": "\\u8DEF\\u5F84 326",
    className: "cls-6",
    d: "M52.784,8.461a.76.76,0,0,0-1.316,0L50.319,10.45l-1.148,1.989a.759.759,0,0,0,.659,1.139h4.593a.759.759,0,0,0,.658-1.139L53.932,10.45Z",
    transform: "translate(7.839 1.291)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_79",
    "data-name": "\\u77E9\\u5F62 79",
    className: "cls-6",
    width: 39.615,
    height: 28.019,
    transform: "translate(14.392 6.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_80",
    "data-name": "\\u77E9\\u5F62 80",
    className: "cls-7",
    width: 0.419,
    height: 1.402,
    transform: "translate(31.343 36.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_81",
    "data-name": "\\u77E9\\u5F62 81",
    className: "cls-7",
    width: 0.419,
    height: 0.419,
    transform: "translate(31.761 37.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_327",
    "data-name": "\\u8DEF\\u5F84 327",
    className: "cls-7",
    d: "M24.281,32.687h-.419a.361.361,0,0,0-.721-.021v1h-.419v-.983a.784.784,0,0,1,.784-.785.775.775,0,0,1,.775.785",
    transform: "translate(3.63 5.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_328",
    "data-name": "\\u8DEF\\u5F84 328",
    className: "cls-7",
    d: "M25.266,32.687v.983h-.419v-.983a.366.366,0,1,0-.732-.021v1H23.7v-.983a.785.785,0,1,1,1.569,0",
    transform: "translate(3.786 5.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_329",
    "data-name": "\\u8DEF\\u5F84 329",
    className: "cls-7",
    d: "M27.051,32.67a.913.913,0,0,1-.419.764v-.043a.56.56,0,0,1-.3.158,1.179,1.179,0,0,1-.189.021.911.911,0,0,1-.91-.91h.419a.492.492,0,1,0,.983,0h.419Z",
    transform: "translate(4.031 5.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_330",
    "data-name": "\\u8DEF\\u5F84 330",
    className: "cls-7",
    d: "M27.051,32.794h-.419a.492.492,0,1,0-.983,0H25.23a.91.91,0,0,1,1.821,0",
    transform: "translate(4.031 5.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_82",
    "data-name": "\\u77E9\\u5F62 82",
    className: "cls-7",
    width: 0.419,
    height: 0.879,
    transform: "translate(33.624 37.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_331",
    "data-name": "\\u8DEF\\u5F84 331",
    className: "cls-7",
    d: "M29.6,32.669a.913.913,0,0,1-.419.764V33.39a.658.658,0,0,1-.3.168,1.178,1.178,0,0,1-.189.021.911.911,0,0,1-.91-.91H28.2a.492.492,0,1,0,.983,0H29.6",
    transform: "translate(4.439 5.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_332",
    "data-name": "\\u8DEF\\u5F84 332",
    className: "cls-7",
    d: "M29.6,32.794h-.419a.492.492,0,1,0-.983,0h-.419a.91.91,0,1,1,1.821,0",
    transform: "translate(4.439 5.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_333",
    "data-name": "\\u8DEF\\u5F84 333",
    className: "cls-7",
    d: "M31.246,31.884a.91.91,0,0,0,0,1.821,1.151,1.151,0,0,0,.188-.021.656.656,0,0,0,.3-.168v.032a.9.9,0,0,0-.492-1.664m0,1.4a.492.492,0,1,1,.492-.492.491.491,0,0,1-.492.492",
    transform: "translate(4.847 5.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_83",
    "data-name": "\\u77E9\\u5F62 83",
    className: "cls-7",
    width: 0.419,
    height: 1.246,
    transform: "translate(40.225 36.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_334",
    "data-name": "\\u8DEF\\u5F84 334",
    className: "cls-7",
    d: "M36.5,32.669a.911.911,0,0,1-1.821,0H35.1a.491.491,0,0,0,.5.481.5.5,0,0,0,.481-.481Z",
    transform: "translate(5.541 5.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_335",
    "data-name": "\\u8DEF\\u5F84 335",
    className: "cls-7",
    d: "M36.5,32.793h-.419a.491.491,0,0,0-.523-.46.479.479,0,0,0-.46.46h-.419a.916.916,0,0,1,.419-.764v.043a.563.563,0,0,1,.3-.158.908.908,0,0,1,1.077.7.919.919,0,0,1,.021.177",
    transform: "translate(5.541 5.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_336",
    "data-name": "\\u8DEF\\u5F84 336",
    className: "cls-7",
    d: "M27.749,33.223l-.209.366a.775.775,0,0,1-.523-.785h.418a.483.483,0,0,0,.314.419",
    transform: "translate(4.316 5.241)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_84",
    "data-name": "\\u77E9\\u5F62 84",
    className: "cls-7",
    width: 0.419,
    height: 1.402,
    transform: "translate(34.304 36.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_85",
    "data-name": "\\u77E9\\u5F62 85",
    className: "cls-7",
    width: 0.419,
    height: 0.419,
    transform: "translate(34.722 37.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_337",
    "data-name": "\\u8DEF\\u5F84 337",
    className: "cls-7",
    d: "M30.3,33.223l-.209.366a.763.763,0,0,1-.523-.785h.418a.483.483,0,0,0,.314.419",
    transform: "translate(4.724 5.241)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_86",
    "data-name": "\\u77E9\\u5F62 86",
    className: "cls-7",
    width: 0.419,
    height: 1.402,
    transform: "translate(37.318 36.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_338",
    "data-name": "\\u8DEF\\u5F84 338",
    className: "cls-7",
    d: "M32.909,33.223l-.209.366a.775.775,0,0,1-.523-.785h.418a.453.453,0,0,0,.314.419",
    transform: "translate(5.141 5.241)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_87",
    "data-name": "\\u77E9\\u5F62 87",
    className: "cls-7",
    width: 0.419,
    height: 0.879,
    transform: "translate(30.663 37.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_88",
    "data-name": "\\u77E9\\u5F62 88",
    className: "cls-7",
    width: 0.419,
    height: 0.879,
    transform: "translate(36.585 37.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_339",
    "data-name": "\\u8DEF\\u5F84 339",
    className: "cls-7",
    d: "M34.71,32.669a.913.913,0,0,1-.419.764V33.4a.56.56,0,0,1-.3.158.91.91,0,0,1-1.079-.7,1.15,1.15,0,0,1-.021-.188h.419a.492.492,0,1,0,.983,0h.419",
    transform: "translate(5.255 5.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_340",
    "data-name": "\\u8DEF\\u5F84 340",
    className: "cls-7",
    d: "M34.71,32.794h-.419a.492.492,0,1,0-.983,0h-.419a.91.91,0,1,1,1.821,0",
    transform: "translate(5.255 5.094)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_89",
    "data-name": "\\u77E9\\u5F62 89",
    className: "cls-7",
    width: 0.419,
    height: 0.879,
    transform: "translate(39.556 37.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_341",
    "data-name": "\\u8DEF\\u5F84 341",
    className: "cls-6",
    d: "M9.517,20.346a2.5,2.5,0,1,1,2.5-2.5,2.5,2.5,0,0,1-2.5,2.5",
    transform: "translate(1.121 2.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_342",
    "data-name": "\\u8DEF\\u5F84 342",
    className: "cls-8",
    d: "M10.768,17.378a.392.392,0,0,1,0,.68l-1.028.593-1.026.593a.392.392,0,0,1-.589-.34V16.531a.393.393,0,0,1,.589-.34l1.026.594Z",
    transform: "translate(1.298 2.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_343",
    "data-name": "\\u8DEF\\u5F84 343",
    className: "cls-6",
    d: "M3.7,20.346a2.5,2.5,0,1,0-2.5-2.5,2.5,2.5,0,0,0,2.5,2.5",
    transform: "translate(0.192 2.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_344",
    "data-name": "\\u8DEF\\u5F84 344",
    className: "cls-8",
    d: "M2.151,17.378a.392.392,0,0,0,0,.68l1.028.593,1.026.593a.392.392,0,0,0,.589-.34V16.531a.393.393,0,0,0-.589-.34l-1.026.594Z",
    transform: "translate(0.312 2.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_345",
    "data-name": "\\u8DEF\\u5F84 345",
    className: "cls-6",
    d: "M4.107,24.949a2.5,2.5,0,1,1,2.5,2.5,2.5,2.5,0,0,1-2.5-2.5",
    transform: "translate(0.656 3.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_346",
    "data-name": "\\u8DEF\\u5F84 346",
    className: "cls-8",
    d: "M6.821,26.2a.392.392,0,0,1-.68,0l-.593-1.028-.593-1.026a.392.392,0,0,1,.34-.589H7.668a.393.393,0,0,1,.34.589l-.594,1.026Z",
    transform: "translate(0.783 3.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_347",
    "data-name": "\\u8DEF\\u5F84 347",
    className: "cls-6",
    d: "M4.107,10.741a2.5,2.5,0,1,0,2.5-2.5,2.5,2.5,0,0,0-2.5,2.5",
    transform: "translate(0.656 1.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_348",
    "data-name": "\\u8DEF\\u5F84 348",
    className: "cls-8",
    d: "M6.821,9.191a.392.392,0,0,0-.68,0l-.593,1.028-.593,1.026a.392.392,0,0,0,.34.589H7.668a.393.393,0,0,0,.34-.589l-.594-1.026Z",
    transform: "translate(0.783 1.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_349",
    "data-name": "\\u8DEF\\u5F84 349",
    className: "cls-6",
    d: "M49.335,24.742a2.749,2.749,0,1,1,2.749,2.749,2.749,2.749,0,0,1-2.749-2.749",
    transform: "translate(7.882 3.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_350",
    "data-name": "\\u8DEF\\u5F84 350",
    className: "cls-9",
    d: "M49.335,17.877a2.749,2.749,0,1,1,2.749,2.749,2.749,2.749,0,0,1-2.749-2.749",
    transform: "translate(7.882 2.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_351",
    "data-name": "\\u8DEF\\u5F84 351",
    className: "cls-8",
    d: "M52.417,11.779H51.326l-.205.614h-.873l1.07-2.914h1.13l1.061,2.914h-.89Zm-.217-.672-.3-.912H51.85l-.3.912Z",
    transform: "translate(8.028 1.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_352",
    "data-name": "\\u8DEF\\u5F84 352",
    className: "cls-8",
    d: "M50.953,23.174h1.088a2.69,2.69,0,0,1,.571.05.958.958,0,0,1,.362.15.536.536,0,0,1,.189.248,1.01,1.01,0,0,1,.055.346.687.687,0,0,1-.093.372.544.544,0,0,1-.332.211v.017a.784.784,0,0,1,.363.226.66.66,0,0,1,.137.445,1.092,1.092,0,0,1-.053.355.58.58,0,0,1-.184.267.915.915,0,0,1-.357.168,2.262,2.262,0,0,1-.564.058H50.953Zm.992,1.146a.911.911,0,0,0,.337-.044c.068-.029.1-.1.1-.208a.189.189,0,0,0-.1-.2.976.976,0,0,0-.337-.042h-.155v.491Zm.063,1.109a1.821,1.821,0,0,0,.212-.01.377.377,0,0,0,.136-.039.165.165,0,0,0,.072-.08.331.331,0,0,0,.021-.126.346.346,0,0,0-.021-.128.175.175,0,0,0-.072-.085.367.367,0,0,0-.133-.045,1.221,1.221,0,0,0-.215-.015h-.218v.529Z",
    transform: "translate(8.141 3.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_353",
    "data-name": "\\u8DEF\\u5F84 353",
    className: "cls-8",
    d: "M51.891,15.607h.045c.013.008.028,0,.042,0a.281.281,0,0,1,.191.092c.071.067.139.138.208.206.449.449.9.9,1.345,1.343a.4.4,0,0,1,.11.378.358.358,0,0,1-.333.264c-.068,0-.065,0-.065.067v1.077a.425.425,0,0,1-.3.406.361.361,0,0,1-.111.013h-.616a.123.123,0,0,1-.14-.14c0-.291,0-.581,0-.872a.177.177,0,0,0-.111-.175.22.22,0,0,0-.078-.015c-.113,0-.225,0-.337,0a.185.185,0,0,0-.168.1.175.175,0,0,0-.021.094v.849a.287.287,0,0,1-.006.071.11.11,0,0,1-.115.093c-.218,0-.436,0-.653,0a.413.413,0,0,1-.39-.406c0-.336,0-.674,0-1.01v-.082c0-.063,0-.063-.064-.065a.363.363,0,0,1-.322-.227.592.592,0,0,1-.016-.09v-.106a.357.357,0,0,1,.113-.213q.776-.772,1.548-1.547a.293.293,0,0,1,.2-.1c.012,0,.024,0,.036,0",
    transform: "translate(7.987 2.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_354",
    "data-name": "\\u8DEF\\u5F84 354",
    className: "cls-8",
    d: "M51.705,15.607v.007a.045.045,0,0,1-.038-.007Z",
    transform: "translate(8.255 2.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_355",
    "data-name": "\\u8DEF\\u5F84 355",
    className: "cls-8",
    d: "M51.6,15.613v-.007h.037a.041.041,0,0,1-.038.007",
    transform: "translate(8.243 2.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_356",
    "data-name": "\\u8DEF\\u5F84 356",
    className: "cls-10",
    d: "M37.82,24.449a6.6,6.6,0,1,1,6.6-6.6,6.6,6.6,0,0,1-6.6,6.6m0-10.826a4.231,4.231,0,1,0,4.231,4.231,4.235,4.235,0,0,0-4.231-4.231",
    transform: "translate(4.989 1.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_357",
    "data-name": "\\u8DEF\\u5F84 357",
    className: "cls-10",
    d: "M40.166,19.164a1.95,1.95,0,1,1,1.951-1.951,1.951,1.951,0,0,1-1.951,1.951",
    transform: "translate(6.105 2.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_358",
    "data-name": "\\u8DEF\\u5F84 358",
    className: "cls-10",
    d: "M23.631,24.449a6.6,6.6,0,1,1,6.6-6.6,6.6,6.6,0,0,1-6.6,6.6m0-10.826a4.231,4.231,0,1,0,4.231,4.231,4.235,4.235,0,0,0-4.231-4.231",
    transform: "translate(2.722 1.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_359",
    "data-name": "\\u8DEF\\u5F84 359",
    className: "cls-10",
    d: "M25.977,19.164a1.95,1.95,0,1,1,1.951-1.951,1.951,1.951,0,0,1-1.951,1.951",
    transform: "translate(3.839 2.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_360",
    "data-name": "\\u8DEF\\u5F84 360",
    className: "cls-11",
    d: "M58.806,20.147a1.137,1.137,0,0,1-1.135-1.137V15.653a1.135,1.135,0,0,1,2.271,0v3.358a1.137,1.137,0,0,1-1.135,1.137m0-5.265a.772.772,0,0,0-.771.771v3.358a.771.771,0,1,0,1.542,0V15.653a.772.772,0,0,0-.771-.771",
    transform: "translate(9.214 2.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_361",
    "data-name": "\\u8DEF\\u5F84 361",
    className: "cls-11",
    d: "M58.239,18.645V15.773a.476.476,0,1,1,.952,0v2.873a.476.476,0,1,1-.952,0",
    transform: "translate(9.305 2.444)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatatacarIllustration);
export default __webpack_public_path__ + "static/media/matatacar-illustration.491c5c426d1bfcb7942a391fc069c148.svg";
export { ForwardRef as ReactComponent };